/**
 * useEmailPopupAnalytics.js
 *
 * Analytics hook for the Email Popup (UC-06). Mirrors
 * useDietPlanAnalytics.js exactly — same GA4 wrapper via react-ga4, same
 * IS_PRODUCTION guard, same dev console.group/table logging.
 */

import { useCallback } from "react";
import ReactGA from "react-ga4";

const IS_PRODUCTION =
  process.env.NODE_ENV === "production" &&
  typeof window !== "undefined" &&
  window.location.hostname !== "localhost" &&
  window.location.hostname !== "127.0.0.1";

const send = (eventName, params = {}) => {
  const cleanParams = Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "")
  );

  if (IS_PRODUCTION) {
    ReactGA.event(eventName, cleanParams);
  } else {
    // eslint-disable-next-line no-console
    console.group(`%c[EmailPopupAnalytics] ${eventName}`, "color:#1565C0;font-weight:bold;");
    // eslint-disable-next-line no-console
    if (Object.keys(cleanParams).length > 0) console.table(cleanParams);
    // eslint-disable-next-line no-console
    else console.log("(no params)");
    // eslint-disable-next-line no-console
    console.groupEnd();
  }
};

const useEmailPopupAnalytics = () => {
  const trackOpen = useCallback((sessionId) => {
    send("email_popup_open", { session_id: sessionId });
  }, []);

  const trackDismiss = useCallback((sessionId) => {
    send("email_popup_dismiss", { session_id: sessionId });
  }, []);

  const trackSubmit = useCallback((sessionId, receiveYogaTips) => {
    send("email_popup_submit", { session_id: sessionId, receive_yoga_tips: receiveYogaTips });
  }, []);

  const trackSubmitSuccess = useCallback((sessionId) => {
    send("email_lead_created", { session_id: sessionId });
  }, []);

  const trackSubmitFailure = useCallback((sessionId, message) => {
    send("email_popup_submit_failure", { session_id: sessionId, message });
  }, []);

  return {
    trackOpen,
    trackDismiss,
    trackSubmit,
    trackSubmitSuccess,
    trackSubmitFailure,
  };
};

export default useEmailPopupAnalytics;
